module.exports = __webpack_public_path__ + "static/img/company-1.6eb166d0.png";